import { publishURL } from './http.js';
import request from './request.js';

export default {
  getListByTypes: item => request(publishURL).post('/common/api/dict/listByTypes', item),
  batchReport: item => request(publishURL).post('/tracker-service/event/batchReport', item)
};